import React, { useState } from 'react';

interface ShortVideo {
  id: string;
  title: string;
}

const YouTubeShortsSimple: React.FC = () => {
  const shortsList: ShortVideo[] = [
    { id: 'fMzL27Mj_nM', title: 'Apoyo a emprendimiento' }, 
    { id: 'jPJcXY8dWGk', title: 'Muro de contención' },    
    { id: '5siCuxP5ZF0', title: 'Asamblea general' }
    // Agrega más videos aquí
  ];

  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const handleNext = (): void => {
    setCurrentIndex((prevIndex: number) => 
      prevIndex === shortsList.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = (): void => {
    setCurrentIndex((prevIndex: number) => 
      prevIndex === 0 ? shortsList.length - 1 : prevIndex - 1
    );
  };

  // Estilos tipados
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    padding: '20px',
    minHeight: '100vh',
    backgroundColor: '#0f0f0f'
  };

  const wrapperStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '20px'
  };

  const videoContainerStyle: React.CSSProperties = {
    width: '340px',
    height: '600px',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
  };

  const buttonStyle: React.CSSProperties = {
    backgroundColor: 'rgba(255,255,255,0.1)',
    border: '1px solid rgba(255,255,255,0.2)',
    color: 'white',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    cursor: 'pointer',
    fontSize: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  const infoStyle: React.CSSProperties = {
    color: 'white',
    textAlign: 'center'
  };

  return (
    <div style={containerStyle}>
      <div style={wrapperStyle}>
        <button 
          onClick={handlePrev}
          style={buttonStyle}
          aria-label="Video anterior"
        >
          ↑
        </button>

        <div style={videoContainerStyle}>
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${shortsList[currentIndex].id}?autoplay=1&mute=1&controls=1&modestbranding=1&rel=0`}
            title={shortsList[currentIndex].title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>

        <button 
          onClick={handleNext}
          style={buttonStyle}
          aria-label="Video siguiente"
        >
          ↓
        </button>
      </div>
      
      <div style={infoStyle}>
        <h3>{shortsList[currentIndex].title}</h3>
        <p>{currentIndex + 1} de {shortsList.length}</p>
      </div>
    </div>
  );
};

export default YouTubeShortsSimple;